import { useFirePageView, useTrackEvent } from "@/libs/analytics/useAnalytics";
import {
  createAchievementsViewedPageEventPayload,
  createAchievementsClickedTrackEventPayload,
  createAchievementDetailsViewedPageEventPayload,
} from "nvs-analytics";
import { AchievementsPayload } from "nvs-analytics/dist/events/track/achievements-clicked";

export const useAchievementsPageViewAnalytics = () => {
  useFirePageView(createAchievementsViewedPageEventPayload, {}, false, true);
};

export const useAchievementsClicked = () => {
  return useTrackEvent(createAchievementsClickedTrackEventPayload);
};

export const useAchievementDetailsPageViewAnalytics = (
  achievementData: AchievementsPayload,
  isReady: boolean,
) => {
  useFirePageView(
    createAchievementDetailsViewedPageEventPayload,
    achievementData,
    false,
    isReady,
  );
};
